export const SITE_ORIGIN = "https://www.happysolutions.hu";
export const SITE_NAME = "Happy Solutions";
export const DEFAULT_LANGUAGE = "hu";
export const SUPPORTED_LANGUAGES = ["hu", "en", "de"];
export const DEFAULT_OG_IMAGE = "https://happy-releases.fra1.cdn.digitaloceanspaces.com/Uploads/Images/happy-web/site-image.jpg";

const DEFAULT_KEYWORDS = {
    hu: [
        "Happy Solutions",
        "ERP rendszer",
        "CRM rendszer",
        "éttermi szoftver",
        "kereskedelmi szoftver",
        "időpontfoglaló rendszer",
        "vállalatirányítás",
        "automatizáció",
        "integrációk",
        "üzleti szoftver"
    ],
    en: [
        "Happy Solutions",
        "ERP software",
        "CRM software",
        "restaurant software",
        "retail software",
        "booking system",
        "business automation",
        "integrations",
        "cloud software",
        "AI-ready business systems"
    ],
    de: [
        "Happy Solutions",
        "ERP Software",
        "CRM Software",
        "Restaurant Software",
        "Handelssoftware",
        "Buchungssystem",
        "Geschäftsautomatisierung",
        "Integrationen",
        "Cloud-Software",
        "KI-fähige Unternehmenssysteme"
    ]
};

const DEFAULT_SEO = {
    hu: {
        title: "Üzleti szoftverek, ERP, CRM, éttermi és kereskedelmi rendszerek",
        description:
      "Happy Solutions: modern ERP, CRM, éttermi, kereskedelmi és időpontfoglaló szoftverek integrációkkal, automatizációval és helyi támogatással.",
        keywords: DEFAULT_KEYWORDS.hu,
    },
    en: {
        title: "Business software, ERP, CRM, restaurant and retail systems",
        description:
      "Happy Solutions delivers modern ERP, CRM, restaurant, retail and booking software with integrations, automation and local support.",
        keywords: DEFAULT_KEYWORDS.en,
    },
    de: {
        title: "Business-Software, ERP, CRM, Restaurant- und Handelssysteme",
        description:
      "Happy Solutions bietet moderne ERP-, CRM-, Restaurant-, Handels- und Buchungssysteme mit Integrationen, Automatisierung und lokalem Support.",
        keywords: DEFAULT_KEYWORDS.de,
    },
};

const ROUTE_SEO = [
    {
        id: "home",
        match: ["/"],
        localizedPaths: {
            hu: "/",
            en: "/",
            de: "/" 
        },
        entityType: "WebPage",
        titles: {
            hu: "Happy Solutions – Modern üzleti rendszerek növekvő vállalkozásoknak",
            en: "Happy Solutions – Modern business systems for growing companies",
            de: "Happy Solutions – Moderne Geschäftssysteme für wachsende Unternehmen",
        },
        descriptions: {
            hu: "ERP, CRM, éttermi, kereskedelmi és szolgáltatói megoldások egy platformon, gyors bevezetéssel, integrációkkal és valós idejű adatokkal.",
            en: "ERP, CRM, restaurant, retail and service solutions on one platform with fast onboarding, integrations and real-time data.",
            de: "ERP-, CRM-, Gastronomie-, Handels- und Servicelösungen auf einer Plattform – mit schneller Einführung, Integrationen und Echtzeitdaten.",
        },
        keywords: {
            hu: [...DEFAULT_KEYWORDS.hu, "Happy Gastro", "Happy Trade", "Happy CRM", "Happy ERP"],
            en: [...DEFAULT_KEYWORDS.en, "Happy Gastro", "Happy Trade", "Happy CRM", "Happy ERP"],
            de: [...DEFAULT_KEYWORDS.de, "Happy Gastro", "Happy Trade", "Happy CRM", "Happy ERP"],
        },
    },
    {
        id: "booking",
        match: ["/foglalas", "/booking"],
        canonicalPath: "/foglalas",
        localizedPaths: {
            hu: "/foglalas",
            en: "/booking",
            de: "/booking" 
        },
        entityType: "Service",
        entityNames: {
            hu: "Ingyenes üzleti konzultáció foglalás",
            en: "Free business consultation booking",
            de: "Kostenlose Business-Beratung buchen",
        },
        titles: {
            hu: "Foglaljon ingyenes konzultációt ERP, CRM vagy iparági rendszeréhez",
            en: "Book a free consultation for your ERP, CRM or industry software",
            de: "Buchen Sie eine kostenlose Beratung für ERP, CRM oder Branchensoftware",
        },
        descriptions: {
            hu: "Válasszon szakértőt és időpontot online. ERP, CRM, éttermi, kereskedelmi és szolgáltatói rendszerekhez személyre szabott konzultáció.",
            en: "Choose an expert and time online. Personalized consultation for ERP, CRM, restaurant, retail and service software projects.",
            de: "Wählen Sie online einen Experten und Termin. Persönliche Beratung für ERP-, CRM-, Gastronomie-, Handels- und Service-Softwareprojekte.",
        },
        keywords: {
            hu: [...DEFAULT_KEYWORDS.hu, "ingyenes konzultáció", "időpontfoglalás", "CRM tanácsadás"],
            en: [...DEFAULT_KEYWORDS.en, "free consultation", "booking page", "CRM consulting"],
            de: [...DEFAULT_KEYWORDS.de, "kostenlose Beratung", "Terminbuchung", "CRM Beratung"],
        },
    },
    {
        id: "crm",
        match: ["/crm-rendszer"],
        localizedPaths: {
            hu: "/crm-rendszer",
            en: "/crm-rendszer",
            de: "/crm-rendszer" 
        },
        entityType: "SoftwareApplication",
        entityNames: {
            hu: "Happy CRM",
            en: "Happy CRM",
            de: "Happy CRM" 
        },
        titles: {
            hu: "CRM rendszer értékesítéshez, ügyfélkezeléshez és automatizációhoz",
            en: "CRM software for sales, customer management and automation",
            de: "CRM-Software für Vertrieb, Kundenmanagement und Automatisierung",
        },
        descriptions: {
            hu: "Happy CRM: lead kezelés, pipeline, feladatok, ügyfélkommunikáció és riportok egy modern, integrálható rendszerben.",
            en: "Happy CRM unifies lead management, pipeline, tasks, customer communication and reporting in a modern integrated system.",
            de: "Happy CRM vereint Lead-Management, Pipeline, Aufgaben, Kundenkommunikation und Reporting in einem modernen integrierten System.",
        },
        keywords: {
            hu: [...DEFAULT_KEYWORDS.hu, "CRM szoftver", "lead kezelés", "értékesítési pipeline"],
            en: [...DEFAULT_KEYWORDS.en, "CRM platform", "lead management", "sales pipeline"],
            de: [...DEFAULT_KEYWORDS.de, "CRM Plattform", "Lead Management", "Vertriebspipeline"],
        },
    },
    {
        id: "erp",
        match: ["/erp-vallalatiranyitasi-rendszer"],
        localizedPaths: {
            hu: "/erp-vallalatiranyitasi-rendszer",
            en: "/erp-vallalatiranyitasi-rendszer",
            de: "/erp-vallalatiranyitasi-rendszer",
        },
        entityType: "SoftwareApplication",
        entityNames: {
            hu: "Happy ERP",
            en: "Happy ERP",
            de: "Happy ERP" 
        },
        titles: {
            hu: "ERP rendszer pénzügyhöz, készlethez, beszerzéshez és vezetői döntésekhez",
            en: "ERP software for finance, inventory, procurement and management decisions",
            de: "ERP-Software für Finanzen, Lager, Einkauf und Managemententscheidungen",
        },
        descriptions: {
            hu: "Happy ERP: moduláris vállalatirányítás automatizációval, riportokkal és integrációkkal a skálázható működésért.",
            en: "Happy ERP is modular business management software with automation, reporting and integrations for scalable operations.",
            de: "Happy ERP ist modulare Unternehmenssoftware mit Automatisierung, Reporting und Integrationen für skalierbare Abläufe.",
        },
        keywords: {
            hu: [...DEFAULT_KEYWORDS.hu, "ERP bevezetés", "készletkezelés", "beszerzés", "riporting"],
            en: [...DEFAULT_KEYWORDS.en, "ERP implementation", "inventory management", "procurement", "reporting"],
            de: [...DEFAULT_KEYWORDS.de, "ERP Einführung", "Lagerverwaltung", "Beschaffung", "Reporting"],
        },
    },
    {
        id: "trade",
        match: ["/trade-kereskedelmi-rendszer"],
        localizedPaths: {
            hu: "/trade-kereskedelmi-rendszer",
            en: "/trade-kereskedelmi-rendszer",
            de: "/trade-kereskedelmi-rendszer",
        },
        entityType: "SoftwareApplication",
        entityNames: {
            hu: "Happy Trade",
            en: "Happy Trade",
            de: "Happy Trade" 
        },
        titles: {
            hu: "Kereskedelmi rendszer POS-szal, készletkezeléssel és automatizációval",
            en: "Retail software with POS, inventory and automation",
            de: "Handelssoftware mit POS, Lagerverwaltung und Automatisierung",
        },
        descriptions: {
            hu: "Happy Trade: gyors értékesítés, raktárkezelés, riportok, árkezelés és integrációk több telephelyes kereskedelemhez is.",
            en: "Happy Trade combines fast POS, stock control, reporting, pricing and integrations for growing retail operations.",
            de: "Happy Trade kombiniert schnelles POS, Bestandskontrolle, Reporting, Preismanagement und Integrationen für wachsende Handelsbetriebe.",
        },
        keywords: {
            hu: [...DEFAULT_KEYWORDS.hu, "POS rendszer", "készletkezelő", "kereskedelmi szoftver"],
            en: [...DEFAULT_KEYWORDS.en, "POS system", "inventory software", "retail platform"],
            de: [...DEFAULT_KEYWORDS.de, "POS System", "Lagersoftware", "Handelsplattform"],
        },
    },
    {
        id: "gastro",
        match: ["/gastro-ettermi-szoftver"],
        localizedPaths: {
            hu: "/gastro-ettermi-szoftver",
            en: "/gastro-ettermi-szoftver",
            de: "/gastro-ettermi-szoftver",
        },
        entityType: "SoftwareApplication",
        entityNames: {
            hu: "Happy Gastro",
            en: "Happy Gastro",
            de: "Happy Gastro" 
        },
        titles: {
            hu: "Éttermi szoftver POS-szal, készlettel, futár- és integrációs modullal",
            en: "Restaurant software with POS, inventory, delivery and integrations",
            de: "Restaurant-Software mit POS, Lager, Liefermodul und Integrationen",
        },
        descriptions: {
            hu: "Happy Gastro: éttermi POS, asztaltérkép, házhozszállítás, készlet, számlázás és Wolt/Foodora integrációk egy rendszerben.",
            en: "Happy Gastro brings restaurant POS, table map, delivery, inventory, invoicing and Wolt/Foodora integrations into one system.",
            de: "Happy Gastro vereint Restaurant-POS, Tischplan, Lieferung, Lager, Rechnungsstellung und Wolt/Foodora-Integrationen in einem System.",
        },
        keywords: {
            hu: [...DEFAULT_KEYWORDS.hu, "éttermi POS", "Wolt integráció", "Foodora integráció", "asztaltérkép"],
            en: [...DEFAULT_KEYWORDS.en, "restaurant POS", "Wolt integration", "Foodora integration", "table map"],
            de: [...DEFAULT_KEYWORDS.de, "Restaurant POS", "Wolt Integration", "Foodora Integration", "Tischplan"],
        },
    },
    {
        id: "service-booking",
        match: ["/services-idopontfoglalo-rendszer"],
        localizedPaths: {
            hu: "/services-idopontfoglalo-rendszer",
            en: "/services-idopontfoglalo-rendszer",
            de: "/services-idopontfoglalo-rendszer",
        },
        entityType: "SoftwareApplication",
        entityNames: {
            hu: "Happy Services Booking",
            en: "Happy Services Booking",
            de: "Happy Services Booking",
        },
        titles: {
            hu: "Időpontfoglaló rendszer szolgáltató cégeknek és több helyszínes működéshez",
            en: "Appointment booking software for service businesses and multi-location teams",
            de: "Terminbuchungssoftware für Dienstleister und Multi-Standort-Teams",
        },
        descriptions: {
            hu: "Online foglalás, naptár, erőforrás-kezelés, értesítések és automatizáció szolgáltató vállalkozások számára.",
            en: "Online booking, calendar, resource planning, notifications and automation for service businesses.",
            de: "Online-Buchung, Kalender, Ressourcenplanung, Benachrichtigungen und Automatisierung für Dienstleistungsunternehmen.",
        },
        keywords: {
            hu: [...DEFAULT_KEYWORDS.hu, "időpontfoglaló szoftver", "online foglalás", "szolgáltatói naptár"],
            en: [...DEFAULT_KEYWORDS.en, "appointment booking software", "online scheduling", "service calendar"],
            de: [...DEFAULT_KEYWORDS.de, "Terminbuchungssoftware", "Online Terminplanung", "Service Kalender"],
        },
    },
    {
        id: "demo",
        match: ["/demo"],
        localizedPaths: {
            hu: "/demo",
            en: "/demo",
            de: "/demo" 
        },
        entityType: "WebPage",
        titles: {
            hu: "Kérjen demót és nézze meg, hogyan illeszkedik a rendszer a cégéhez",
            en: "Request a demo and see how the system fits your business",
            de: "Demo anfordern und sehen, wie das System zu Ihrem Unternehmen passt",
        },
        descriptions: {
            hu: "Kérjen személyre szabott bemutatót ERP, CRM, éttermi, kereskedelmi vagy szolgáltatói rendszerünkhöz.",
            en: "Request a tailored demo for our ERP, CRM, restaurant, retail or service software platform.",
            de: "Fordern Sie eine individuelle Demo für unsere ERP-, CRM-, Gastronomie-, Handels- oder Service-Software an.",
        },
        keywords: {
            hu: [...DEFAULT_KEYWORDS.hu, "demó igénylés", "szoftver bemutató"],
            en: [...DEFAULT_KEYWORDS.en, "request demo", "software demo"],
            de: [...DEFAULT_KEYWORDS.de, "Demo anfordern", "Software Demo"],
        },
    },
    {
        id: "contact",
        match: ["/kapcsolat/elerhetosegeink", "/kapcsolat/ugyfelszolgalat", "/elerhetosegeink"],
        canonicalPath: "/kapcsolat/elerhetosegeink",
        localizedPaths: {
            hu: "/kapcsolat/elerhetosegeink",
            en: "/kapcsolat/elerhetosegeink",
            de: "/kapcsolat/elerhetosegeink",
        },
        entityType: "ContactPage",
        titles: {
            hu: "Kapcsolat, ügyfélszolgálat és elérhetőségek",
            en: "Contact, customer support and business inquiries",
            de: "Kontakt, Kundensupport und Geschäftsanfragen",
        },
        descriptions: {
            hu: "Vegye fel velünk a kapcsolatot értékesítés, támogatás, demó vagy integrációs kérdések esetén.",
            en: "Contact Happy Solutions for sales, support, demos or integration questions.",
            de: "Kontaktieren Sie Happy Solutions bei Vertrieb, Support, Demo- oder Integrationsfragen.",
        },
        keywords: {
            hu: [...DEFAULT_KEYWORDS.hu, "kapcsolat", "ügyfélszolgálat", "demó kapcsolat"],
            en: [...DEFAULT_KEYWORDS.en, "contact", "customer support", "sales inquiry"],
            de: [...DEFAULT_KEYWORDS.de, "Kontakt", "Kundensupport", "Vertriebsanfrage"],
        },
    },
    {
        id: "integrations",
        match: ["/integraciok"],
        localizedPaths: {
            hu: "/integraciok",
            en: "/integraciok",
            de: "/integraciok" 
        },
        entityType: "CollectionPage",
        titles: {
            hu: "Integrációk: pénzügy, szállítás, fizetés, könyvelés és API kapcsolatok",
            en: "Integrations: finance, delivery, payments, accounting and APIs",
            de: "Integrationen: Finanzen, Lieferung, Zahlungen, Buchhaltung und APIs",
        },
        descriptions: {
            hu: "Fedezze fel a Happy Solutions integrációit: fizetés, futárszolgálatok, könyvelés, webshop, számlázás és egyedi API kapcsolatok.",
            en: "Explore Happy Solutions integrations across payments, delivery, accounting, ecommerce, invoicing and custom APIs.",
            de: "Entdecken Sie Happy Solutions Integrationen für Zahlungen, Lieferung, Buchhaltung, E-Commerce, Rechnungsstellung und individuelle APIs.",
        },
        keywords: {
            hu: [...DEFAULT_KEYWORDS.hu, "API integráció", "Billingo", "Számlázz.hu", "fizetési integráció"],
            en: [...DEFAULT_KEYWORDS.en, "API integrations", "payments", "accounting integrations"],
            de: [...DEFAULT_KEYWORDS.de, "API Integrationen", "Zahlungen", "Buchhaltungsintegrationen"],
        },
    },
];

export const normalizeSeoPath = (pathname = "/") => {
    let clean = pathname || "/";

    try {
        clean = clean.split("?")[0].split("#")[0];
    } catch (error) {
        clean = "/";
    }
    clean = clean.replace(/^\/(en|de)(?=\/|$)/i, "") || "/";
    if (!clean.startsWith("/")) {
        clean = `/${clean}`;
    }
    if (clean.length > 1) {
        clean = clean.replace(/\/+$/, "");
    }

    return clean || "/";
};

export const detectLanguage = (preferredLanguage, pathname = "/") => {
    const normalized = (preferredLanguage || "").toLowerCase().split(/[-_]/)[0];

    if (SUPPORTED_LANGUAGES.includes(normalized)) {
        return normalized;
    }
    const pathMatch = (pathname || "").match(/^\/(en|de)(?=\/|$)/i);

    return pathMatch ? pathMatch[1].toLowerCase() : DEFAULT_LANGUAGE;
};

export const buildLocalizedPath = (path, language = DEFAULT_LANGUAGE) => {
    const normalizedPath = path && path !== "/" ? path : "/";

    if (language === DEFAULT_LANGUAGE) {
        return normalizedPath;
    }

    return normalizedPath === "/" ? `/${language}` : `/${language}${normalizedPath}`;
};

export const buildAbsoluteUrl = (path, language = DEFAULT_LANGUAGE) => `${SITE_ORIGIN}${buildLocalizedPath(path, language)}`;

export const getDefaultSeo = (language = DEFAULT_LANGUAGE) => DEFAULT_SEO[language] || DEFAULT_SEO[DEFAULT_LANGUAGE];
export const getDefaultKeywords = (language = DEFAULT_LANGUAGE) => DEFAULT_KEYWORDS[language] || DEFAULT_KEYWORDS[DEFAULT_LANGUAGE];

export const getRouteSeo = (pathname = "/", language = DEFAULT_LANGUAGE) => {
    const normalizedPath = normalizeSeoPath(pathname);
    const route = ROUTE_SEO.find((entry) => entry.match.includes(normalizedPath)) || null;

    if (!route) {
        return {
            id: "default",
            localizedPath: normalizedPath,
            title: getDefaultSeo(language).title,
            description: getDefaultSeo(language).description,
            keywords: getDefaultKeywords(language),
            entityType: "WebPage",
        };
    }

    const localizedPath = route.localizedPaths?.[language] || route.localizedPaths?.[DEFAULT_LANGUAGE] || route.canonicalPath || route.match[0];

    return {
        ...route,
        localizedPath,
        title: route.titles?.[language] || route.titles?.[DEFAULT_LANGUAGE] || getDefaultSeo(language).title,
        description: route.descriptions?.[language] || route.descriptions?.[DEFAULT_LANGUAGE] || getDefaultSeo(language).description,
        keywords: route.keywords?.[language] || route.keywords?.[DEFAULT_LANGUAGE] || getDefaultKeywords(language),
        entityName: route.entityNames?.[language] || route.entityNames?.[DEFAULT_LANGUAGE] || route.titles?.[language],
    };
};

export const getAlternateLinks = (routeSeo) => {
    const pathMap = routeSeo.localizedPaths || { [DEFAULT_LANGUAGE]: routeSeo.localizedPath || "/" };
    const alternates = SUPPORTED_LANGUAGES.map((language) => ({
        hrefLang: language,
        href: buildAbsoluteUrl(pathMap[language] || pathMap[DEFAULT_LANGUAGE] || routeSeo.localizedPath || "/", language),
    }));

    return [
        ...alternates,
        {
            hrefLang: "x-default",
            href: buildAbsoluteUrl(pathMap[DEFAULT_LANGUAGE] || routeSeo.localizedPath || "/", DEFAULT_LANGUAGE),
        },
    ];
};

const buildBreadcrumbJsonLd = (routeSeo, language, pageUrl) => ({
    "@type": "BreadcrumbList",
    itemListElement: [
        {
            "@type": "ListItem",
            position: 1,
            name: SITE_NAME,
            item: buildAbsoluteUrl("/", language),
        },
        {
            "@type": "ListItem",
            position: 2,
            name: routeSeo.entityName || routeSeo.title,
            item: pageUrl,
        },
    ],
});

const buildPrimaryEntityJsonLd = (routeSeo, language, pageUrl) => {
    if (routeSeo.entityType === "SoftwareApplication") {
        return {
            "@type": "SoftwareApplication",
            name: routeSeo.entityName,
            applicationCategory: "BusinessApplication",
            operatingSystem: "Web browser",
            url: pageUrl,
            inLanguage: language,
            image: DEFAULT_OG_IMAGE,
            description: routeSeo.description,
            publisher: { "@id": `${SITE_ORIGIN}/#organization` },
            brand: { "@id": `${SITE_ORIGIN}/#organization` },
        };
    }

    if (routeSeo.entityType === "Service") {
        return {
            "@type": "Service",
            name: routeSeo.entityName || routeSeo.title,
            serviceType: routeSeo.entityName || routeSeo.title,
            description: routeSeo.description,
            url: pageUrl,
            provider: { "@id": `${SITE_ORIGIN}/#organization` },
            areaServed: ["HU", "EU"],
            availableLanguage: ["hu", "en", "de"],
        };
    }

    return null;
};

export const buildSeoJsonLd = ({
    routeSeo, language = DEFAULT_LANGUAGE, title, description, pageUrl 
}) => {
    const websiteUrl = buildAbsoluteUrl("/", language);
    const webpage = {
        "@type": routeSeo.entityType === "ContactPage" ? "ContactPage" : routeSeo.entityType === "CollectionPage" ? "CollectionPage" : "WebPage",
        "@id": `${pageUrl}#webpage`,
        url: pageUrl,
        name: title,
        description,
        inLanguage: language,
        isPartOf: { "@id": `${SITE_ORIGIN}/#website` },
        about: { "@id": `${SITE_ORIGIN}/#organization` },
        primaryImageOfPage: DEFAULT_OG_IMAGE,
    };

    const website = {
        "@type": "WebSite",
        "@id": `${SITE_ORIGIN}/#website`,
        url: websiteUrl,
        name: SITE_NAME,
        inLanguage: SUPPORTED_LANGUAGES,
        publisher: { "@id": `${SITE_ORIGIN}/#organization` },
        potentialAction: {
            "@type": "SearchAction",
            target: `${SITE_ORIGIN}/?s={search_term_string}`,
            "query-input": "required name=search_term_string",
        },
    };

    const organization = {
        "@type": "Organization",
        "@id": `${SITE_ORIGIN}/#organization`,
        name: SITE_NAME,
        url: SITE_ORIGIN,
        logo: {
            "@type": "ImageObject",
            url: `${SITE_ORIGIN}/favicon.png`,
        },
        sameAs: [
            "https://www.facebook.com/gastrohappy",
            "https://www.linkedin.com/company/happy-gastro/",
            "https://www.happygastro.hu",
            "https://www.happycrm.hu",
            "https://www.happyerp.hu",
            "https://www.happytrade.hu"
        ],
        contactPoint: [
            {
                "@type": "ContactPoint",
                contactType: "sales",
                email: "info@happysolutions.hu",
                telephone: "+36 1 300 9105",
                areaServed: ["HU", "EU"],
                availableLanguage: ["hu", "en", "de"],
            },
        ],
    };

    const primaryEntity = buildPrimaryEntityJsonLd(routeSeo, language, pageUrl);
    const breadcrumb = buildBreadcrumbJsonLd(routeSeo, language, pageUrl);

    return [organization, website, webpage, breadcrumb, primaryEntity].filter(Boolean);
};

export const getPrefetchTargets = (language = DEFAULT_LANGUAGE) => {
    const topRoutes = ["/foglalas", "/demo", "/crm-rendszer", "/erp-vallalatiranyitasi-rendszer", "/gastro-ettermi-szoftver"];

    return topRoutes.map((route) => buildLocalizedPath(route, language));
};

